export default __webpack_public_path__ + "static/media/canada.2ba465d6.png";